import { Component, OnInit } from '@angular/core';

import { EngagementModel } from '../../models/engagement.model';
import { EngagementService } from '../../services/engagement.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { Sharedservice } from '../../shared-components/shared.service';
import { CoverIndexService } from '../../services/coverindex.service';
import { severitymessage, DeleteEngagementComponentmessage, LanguageConstants } from '../../shared-components/constant';
import { environment } from 'src/environments/environment';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';

@Component({
  standalone: false,
  selector: 'app-deleteprojectdata',
  templateUrl: './deleteprojectdata.component.html',
  styleUrls: ['./deleteprojectdata.component.css']
})
export class DeleteprojectdataComponent implements OnInit {
  engagementid: string;
  engid: number;
  loadspinner = false;
  private EnvName = environment.ENV;
  langCode: string;
  currLangTranslation: any;
  constructor(private engagementService: EngagementService, private route: ActivatedRoute, private messageService: MessageService
    , private router: Router, private confirmationService: ConfirmationService
    , public sharedService: Sharedservice, private coverIndexService: CoverIndexService, private translateService: TranslateService) {
    // this.selectedRegion = localStorage.getItem('selectedregion');
    // this.engId = +this.route.snapshot.paramMap.get('id');
  }

  ngOnInit() {
    this.langCode = localStorage.getItem(LanguageConstants.LANG_CODE);
    this.currLangTranslation = this.translateService.translations[this.langCode];
    this.translateService.onLangChange.subscribe((langEvent: LangChangeEvent) => {
      this.currLangTranslation = langEvent.translations;
    });
    this.messageService.clear('myKey1');
    if (this.EnvName === 'Prod') {
      this.router.navigate(['/home']);
    }
  }

  deleteEngagement() {
    const nameArr = this.engagementid.split(',');
    for (const num of nameArr) {
      this.engid = parseInt(num);
      this.loadspinner = true;
      this.engagementService.deleteEngagement(this.engid,null)
        .subscribe((data) => {
          this.messageService.add({
            key: this.currLangTranslation.severitymessage.key2, severity: severitymessage.success,
            summary: this.currLangTranslation.severitymessage.notification, detail: DeleteEngagementComponentmessage.SuccessMessage.ProjectClose +
              ` Engagement ID: ${num}`, life: 10000
          });
          this.engagementid = '';
        }, error => {
          this.messageService.add({
            key: this.currLangTranslation.severitymessage.key2, severity: severitymessage.error,
            summary: this.currLangTranslation.severitymessage.notification, detail: DeleteEngagementComponentmessage.ErrorMessage.CloseProject
            , sticky: true, closable: true
          });
          this.engagementid = '';
        });
    }
  }
}
